import { useEffect, useRef } from "react";
import config from "../../../config";
import { authFetch } from "../../../utils/Security/authFetch";

export const useFetchFullName = (setUser: (fullName: string) => void) => {
  const setUserRef = useRef(setUser);

  useEffect(() => {
    setUserRef.current = setUser;
  }, [setUser]);

  useEffect(() => {
    const fetchFullName = async () => {
      try {
        const username = localStorage.getItem("username");
       if (!username) return;

    // Use query parameter instead of path parameter
    const response = await authFetch(
      `${config.apiBaseUrl}/api/users/by-username?username=${encodeURIComponent(username)}`
    );

        
        if (!response.ok) throw new Error("Failed to fetch full name");

        const fullName = await response.text();
        setUserRef.current(fullName); // Use ref here
      } catch (error) {
        console.error("Error fetching full name:", (error as Error).message);
      }
    };

    fetchFullName();
  }, []);
};
